import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import {
  associateSkillWithAuthenticatedUser,
  disassociateSkillWithAuthenticatedUser,
  createAndClaimUnrecognizedSkill,
} from './restApi';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';

const SkillsModalTable = () => {
  const state = useProfileState();
  const { onResponse, onError } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const newUnrecognizedSkillNotFoundInPreexistingSkills =
    !state?.skillsModal?.skills.some(skill =>
      skill.name?.toLowerCase() === state?.skillsModal?.newUnrecognizedSkillForm?.skillName?.toLowerCase()
    );

  const newUnrecognizedSkillFormHasContent =
    state?.skillsModal?.newUnrecognizedSkillForm?.skillName &&
    state?.skillsModal?.newUnrecognizedSkillForm?.skillName?.length > 0;

  const displayedSkills = [...state?.skillsModal?.skills];

  if (newUnrecognizedSkillFormHasContent && newUnrecognizedSkillNotFoundInPreexistingSkills) {
    displayedSkills.unshift({
      name: state?.skillsModal?.newUnrecognizedSkillForm?.skillName,
      claimedByAuthenticatedUser: false,
      aasmState: 'Does not exist in database',
      isInjected: true,
    });
  }

  if (displayedSkills.length === 0) {
    return null;
  }

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Claimed By You</Th>
          <Th>State</Th>
          <Th />
        </Tr>
      </Thead>
      <Tbody>
        {displayedSkills.map(skill => (
          <Tr key={skill.id}>
            <Td>{skill.name}</Td>
            <Td>{skill.claimedByAuthenticatedUser ? 'Yes' : 'No'}</Td>
            <Td>{skill.aasmState}</Td>
            <Td>
              <ActionRow align="end">
                {skill.claimedByAuthenticatedUser && (
                  <Button
                    onClick={() => {
                      disassociateSkillWithAuthenticatedUser({
                        body: {
                          skillId: skill.id,
                          pageNumber: state?.skillsModal?.pageNumber,
                          newUnrecognizedSkillForm: state?.skillsModal?.newUnrecognizedSkillForm,
                          debouncedSkillNameForFuzzyFilter: state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
                          authenticityToken,
                        },
                        onResponse,
                        onError,
                      });
                    }}
                  >
                    Unclaim
                  </Button>
                )}
                {!skill.claimedByAuthenticatedUser && skill.isInjected && (
                  <Button
                    onClick={() => {
                      createAndClaimUnrecognizedSkill({
                        onResponse,
                        onError,
                        body: {
                          newUnrecognizedSkillForm: state?.skillsModal?.newUnrecognizedSkillForm,
                          pageNumber: state?.skillsModal?.pageNumber,
                          debouncedSkillNameForFuzzyFilter: state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
                          authenticityToken,
                        },
                      });
                    }}
                  >
                    Create And Claim
                  </Button>
                )}
                {!skill.claimedByAuthenticatedUser && !skill.isInjected && (
                  <Button
                    onClick={() => {
                      associateSkillWithAuthenticatedUser({
                        body: {
                          skillId: skill.id,
                          pageNumber: state?.skillsModal?.pageNumber,
                          newUnrecognizedSkillForm: state?.skillsModal?.newUnrecognizedSkillForm,
                          debouncedSkillNameForFuzzyFilter: state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
                          authenticityToken,
                        },
                        onResponse,
                        onError,
                      });
                    }}
                  >
                    Claim
                  </Button>
                )}
              </ActionRow>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default SkillsModalTable;
